import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import { getPartsDescription } from '../../api/ebs-mfg-api/index.js';
import { useApiReady } from '@pella/fetch-client-react';

const defaultParams = { input: undefined, enabled: false };

/**
 * Hook to access part descriptions.
 * @param {{input: Local.GetPartsDescriptionInput | undefined, enabled: boolean}} params - input object with partNumber and enabled flag
 */
export const usePartDescription = (params = defaultParams) => {
  const { input, enabled } = params;
  const { apiReady } = useApiReady();
  const partNumber = input?.partNumber;

  return useQuery({
    queryKey: [QUERY_KEYS.PART_DESCRIPTION_DATA, partNumber],
    queryFn: async () => {
      const partDescriptions = await getPartsDescription({ partNumber: String(partNumber) });

      return partDescriptions;
    },
    staleTime: Infinity,
    enabled: Boolean(apiReady && partNumber && partNumber.length > 5 && enabled),
  });
};
